import React from 'react';
import { InputField, ListField } from '@applications-terrains/birdz-react-library';
import { ParamsConfigType } from '../../Admin/Params/Types';
import { t } from 'i18next';

export const generateListFields = (config: ParamsConfigType): ListField[] => {
  const defaultListFields: ListField[] =
    config.value === 'families'
      ? []
      : [
        {
          name: 'id',
          label: 'ID',
          options: {
            renderFormAdd: () => <></>,
            renderFormEdit: (row: any) => <>{row.id}</>
          }
        }
      ];

  const newListFields = [...defaultListFields];

  if (config.extraFields) {
    config.extraFields.forEach((extraField) => {
      const label = t(extraField.label);
      const newField: ListField = {
        ...extraField,
        label: label,
        options: {
          renderForm: () => (
            <InputField size="small" label={label} name={extraField.name} type={extraField.type} />
          )
        }
      };
      newListFields.push(newField);
    });
  }
  return newListFields;
};
